<template>
	<div>
		<BaseButton
			class="layout-button toggle-dev-tools pr-8 pl-12 hover:bg-gray-500 hover:text-gray-100"
			:class="[$sessionLayout.devToolsHidden ? 'bg-gray-650 text-gray-350' : 'bg-gray-550']"
			:aria-checked="$sessionLayout.devToolsHidden ? 'false' : 'true'"
			data-test="session-layout-button-dev-tools"
			role="switch"
			@click="$sessionLayout.toggleDevToolsPanel({from: 'panel layout buttons'})"
		>
			<template #icon><BaseIcon name="mono/devtools2" /></template>
			<BaseTooltip :text="($sessionLayout.devToolsHidden ? 'Show' : 'Hide') + ' Developer Tools Panel'">
				DevTools
			</BaseTooltip>
		</BaseButton>
		<BaseButton
			class="layout-button toggle-details pr-12 pl-8 hover:bg-gray-500 hover:text-gray-100"
			:class="[$sessionLayout.detailsHidden ? 'bg-gray-650 text-gray-350' : 'bg-gray-550']"
			:aria-checked="$sessionLayout.detailsHidden ? 'false' : 'true'"
			data-test="session-layout-button-details"
			role="switch"
			@click="$sessionLayout.toggleDetailsPanel({from: 'panel layout buttons'})"
		>
			<template #icon><BaseIcon name="mono/info" /></template>
			<BaseTooltip :text="($sessionLayout.detailsHidden ? 'Show' : 'Hide') + ' Details Panel'">
				Details
			</BaseTooltip>
		</BaseButton>
	</div>
</template>

<style scoped>
.layout-button {
	height: 28px;
	border-width: 1px;
	border-color: var(--gray-900);
}
.toggle-dev-tools {
	border-top-left-radius: 8px;
	border-bottom-left-radius: 8px;
	border-right-width: 0;
}
.toggle-details {
	border-top-right-radius: 8px;
	border-bottom-right-radius: 8px;
}
</style>
